import moment from 'moment';
import { sortByDate } from '../sorting';
import { ILine } from '../../global';
import { getLineEndDate } from './start-end';
import { getLineContainerStartDate } from './start-end';
import { ITimelineInfo } from '../../Types';
import cloneDeep from 'lodash.clonedeep';

export function getLineDurationInfo(line: ILine, moveDates: boolean = false) {
  const stages = sortByDate(cloneDeep(line.stages));
  let startOfLine = moment.utc(stages[0].start);
  let endOfLine = moment.utc(stages[stages.length - 1].start);
  if (moveDates) {
    startOfLine = startOfLine.startOf('month');
    endOfLine = endOfLine.endOf('month');
  }
  const totalDaysInLine = endOfLine.diff(startOfLine, 'days');
  return { startOfLine, endOfLine, totalDaysInLine };
}

export function getStagesInTimeline(line: ILine, timelineInfo: any) {
  const stagesCopy = cloneDeep(line.stages);
  const stagesInTimeline = stagesCopy.filter((stage) => {
    const stageDate = moment(stage.start);
    if (stageDate >= timelineInfo.start && stageDate <= timelineInfo.end) {
      return stage;
    } else {
      return undefined;
    }
  });
  return stagesInTimeline;
}

export function getVisibleStartDate(line: ILine, timelineInfo: ITimelineInfo) {
  // BASED ON WHAT IS SHOWN IN TIMELINE
  let startOfLine = getLineContainerStartDate(line);
  if (startOfLine < timelineInfo.start) {
    startOfLine = timelineInfo.start;
  }
  return startOfLine;
}

export function getVisibleEndDate(line: ILine, timelineInfo: ITimelineInfo) {
  // BASED ON WHAT IS SHOWN IN TIMELINE
  let endOfLine = getLineEndDate(line);
  if (endOfLine > timelineInfo.end) {
    endOfLine = timelineInfo.end;
  }
  return endOfLine;
}

export const getLinePosition = (line: ILine, timelineInfo: ITimelineInfo) => {
  const totalNumberOfColumns = timelineInfo.months?.length;
  const { startOfLine, endOfLine } = getLineDurationInfo(line, true);
  let startColumn =
    Math.round(
      startOfLine.startOf('month').diff(timelineInfo.start, 'M', true),
    ) + 1;
  const durationInMonths = endOfLine.diff(startOfLine, 'M');
  let endColumn = startColumn + durationInMonths + 1;
  if (startColumn < 1) {
    startColumn = 1;
  }
  if (endColumn > totalNumberOfColumns + 1) {
    endColumn = totalNumberOfColumns + 1;
  }
  if (startColumn > totalNumberOfColumns && endColumn > totalNumberOfColumns) {
    startColumn = 0;
    endColumn = 0;
  }
  if (line.edit && startColumn > 0) {
    endColumn += 1;
  }
  return { startColumn, endColumn };
};
